import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { EditUserForm } from "./EditUserForm";
export var EditUser = function (_a) {
    var id = _a.id, close = _a.close, electionEventId = _a.electionEventId, electionId = _a.electionId, rolesList = _a.rolesList, userAttributes = _a.userAttributes, record = _a.record;
    var _b = useState(true), renderUI = _b[0], setRenderUI = _b[1];
    useEffect(function () {
        if (record) {
            setRenderUI(true);
        }
    }, [record]);
    if (renderUI) {
        return (_jsx(EditUserForm, { id: id, electionEventId: electionEventId, electionId: electionId, close: close, rolesList: rolesList, userAttributes: userAttributes, record: record }));
    }
    else {
        return null;
    }
};
